import React, {Fragment} from 'react';
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";
import './CostAndProfitDataPrintList.scss'

const CostAndProfitDataPrintList = (props) => {
  const {data} = props;
  console.log(data)

  return <div className={'CostAndProfitDataPrintList'}>
    {
      data.map((row, index) => {
        console.log(row)

        return <Fragment key={index}>
          <ul className={'d-flex justify-content-between w-100'}>
            <li>{row.title}</li>
            <li>{formatToPersianAddComma(row.remaining)}</li>
          </ul>
        </Fragment>


      })
    }
  </div>;
};

export default CostAndProfitDataPrintList;
